
import { Component, OnInit ,ViewChild} from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { FormControl, FormGroup  } from '@angular/forms';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesSimuladorAgregarDetalle } from '../../../models/messages';
import { Router  } from '@angular/router';
import { CobranzasService } from '../../../services/cobranzas/cobranzas.service';
import { HttpClient } from '@angular/common/http';

import * as XLSX from 'xlsx';
import { environment } from 'environments/environment';

export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-adquirente-cuota',
  templateUrl: './adquirente-cuota.component.html',
  styleUrls: ['./adquirente-cuota.component.scss'],
  providers:[DatePipe,MessagesTitles,MessagesGeneral,MessagesDates,MessagesSimuladorAgregarDetalle,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class AdquirenteCuotaComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  flagProformaDetalle : boolean = false;
  abrirDetallePagos : boolean = false;
  
  idProforma : number = 0;
  IdCuota :string;
  

  proformas : any = [];
  ruc = new FormControl();
  rucAdq = new FormControl();
  rucAdqFilter = new FormControl('');
  rucProvFilter = new FormControl('');
  TipoMonedaFilter = new FormControl('');

  idProv ="" ;
  idAdq ="";
  id :string = '';

  ipAddress = '';
  


  // Entradas de Busqueda
  RUC_PROV : string;
  RUC_ADQ : string;
  TipoMoneda : any = 0;

  filteredProveeedor: Observable<any[]>;
  proveedoresArr;
  dataFiltro : FormGroup;
  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  // usuarios:any[]=[];
  pageSizeOptions = [15,20,30,50,100,200];
  loading:boolean;
  displayedColumns: string[] = 
            ['checked','Fecha','RazonSocialAdquirente','RazonSocialProveedor','Factura','NCuota','Moneda','Importe','Importe_Pendiente','Importe_Ejecutado','Importe_Ajuste'];
   
  filterValues = {
    RazonSocialAdquirente: '',
    RazonSocialProveedor:'',
    Estado:'',
    Moneda:'',
    From: '',
    To: ''
    };

  dataSource =new MatTableDataSource();

  montoTotal:number= 0;
  montoTotalDolares:number= 0;
  constructor( private http:HttpClient,private cobranzasService:CobranzasService,private datePipe :DatePipe , private router:Router) { 
    this.dataFiltro = new FormGroup({
      "Estado":new FormControl(''),
      "Moneda":new FormControl(0),
      fromDate: new FormControl(),
      toDate: new FormControl()      
    });  
  }

  ngOnInit() {
    
    this.ListadoCuotas();

    this.rucAdqFilter.valueChanges
    .subscribe(
      RazonSocialAdquirente => {
        this.filterValues.RazonSocialAdquirente = RazonSocialAdquirente;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
    this.rucProvFilter.valueChanges
    .subscribe(
      RazonSocialProveedor => {
        this.filterValues.RazonSocialProveedor = RazonSocialProveedor;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
    this.dataFiltro.get('Moneda').valueChanges
      .subscribe(
        Moneda => {
          this.filterValues.Moneda = Moneda;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
    )
    this.dataFiltro.get('Estado').valueChanges
      .subscribe(
        Estado => {
          this.filterValues.Estado = Estado;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.dataFiltro.get('fromDate').valueChanges.subscribe(
        from => {
          this.filterValues.From = (from === null ? "" : this.datePipe.transform(from,'yyyy-MM-dd'));
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
      this.dataFiltro.get('toDate').valueChanges.subscribe(
        to => {
          this.filterValues.To = (to === null ? "" : this.datePipe.transform(to,'yyyy-MM-dd')); 
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      const elem=document.getElementById('element-button');
      elem.style.display='flex';
  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.RazonSocialAdquirente.toString().toLowerCase().indexOf(searchTerms.RazonSocialAdquirente) !== -1
      && data.RazonSocialProveedor.toString().toLowerCase().indexOf(searchTerms.RazonSocialProveedor) !== -1
      && data.Moneda.toString().toLowerCase().indexOf(searchTerms.Moneda) !== -1 
      && data.Estado === (searchTerms.Estado == "" ? data.Estado : searchTerms.Estado)
      && data.Fecha_de_Pago >= (searchTerms.From == "" ? data.Fecha_de_Pago : searchTerms.From)
      && data.Fecha_de_Pago <= (searchTerms.To == "" ? data.Fecha_de_Pago : searchTerms.To)
    }
  }

  tipoMoneda(event){
    if(event==''){
      this.TipoMoneda = 0;
      this.dataFiltro.controls["Moneda"].setValue('')
    }else{
      this.TipoMoneda = event;
      this.dataFiltro.controls["Moneda"].setValue(event)
    } 
  }

  ListadoCuotas(){
    this.limpiar();
    this.loading = true;
    this.cobranzasService.ObtenerCuotasPago(this.TipoMoneda,this.id)                                                                                            
    .subscribe(
        res => {
          this.proformas = res;
          console.log('cuotas',this.proformas)
          this.dataSource = new MatTableDataSource( this.proformas);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.dataSource.filterPredicate = this.createFilter();
          this.loading = false;
        } , err =>{
            Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });        
          this.loading = false;
        }
    )
  }

  ExportTOExcel() {    
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.proformas);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let fecha = new Date();
    XLSX.writeFile(wb, 'Listado_Cuotas' + fecha + '.xlsx');
  }

  CerrarPopUpDetallePago(){
    this.abrirDetallePagos = false;
  }

  limpiar(){
    this.proformas.map(object => object.checked = false);
    this.montoTotal=0
    this.montoTotalDolares=0
  }

  Calcular(event,valor,moneda){
    if(moneda==this.Label_id_dolares && event.checked == true){
      this.montoTotalDolares += Number(valor);
    }else if(moneda==this.Label_id_dolares && event.checked == false){
      this.montoTotalDolares -= Number(valor);
    }else if(moneda!==this.Label_id_dolares && event.checked == true){
      this.montoTotal += Number(valor);
    }else if(moneda!==this.Label_id_dolares && event.checked == false){
      this.montoTotal -= Number(valor);
    }
    
  }

}
